var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-5" },
    [
      _c(
        "el-row",
        { staticClass: "pt-30 pb-30 bg-white" },
        [
          _c(
            "el-col",
            { attrs: { span: 12, offset: 5 } },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "180px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "银行卡号：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.bank_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bank_id", $$v)
                          },
                          expression: "form.bank_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属银行：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.bank_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bank_name", $$v)
                          },
                          expression: "form.bank_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属分行：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.bank_branch_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bank_branch_name", $$v)
                          },
                          expression: "form.bank_branch_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "微信收款名：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.wx_account_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "wx_account_name", $$v)
                          },
                          expression: "form.wx_account_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "微信收款码：" } },
                    [
                      _c("upload", {
                        model: {
                          value: _vm.form.wx_account_qrcode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "wx_account_qrcode", $$v)
                          },
                          expression: "form.wx_account_qrcode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付宝收款名：" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.zfb_account_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "zfb_account_name", $$v)
                          },
                          expression: "form.zfb_account_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "支付宝收款码：" } },
                    [
                      _c("upload", {
                        model: {
                          value: _vm.form.zfb_account_qrcode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "zfb_account_qrcode", $$v)
                          },
                          expression: "form.zfb_account_qrcode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }